import type { DentalOfficeShiftCardProps, DentalOfficeShiftCardStatus } from '@tempmee/react-blocks';

/**
 * The DS `DentalOfficeShiftCard` lifecycle statuses as a runtime const, so consumers
 * (status Sets, job→card mappers) reference one source instead of scattering raw string
 * literals. Distinct from `StatusEnum` (legacy uppercase display labels) — these are the
 * block's own states. `satisfies` keeps each value checked against the DS union.
 */
export const SHIFT_CARD_STATUS = {
  OPEN: 'open',
  SCHEDULED: 'scheduled',
  CURRENT: 'current',
  CONFIRM_CANDIDATES: 'confirm-candidates',
  REVIEW_HOURS: 'review-hours',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
} as const satisfies Record<string, DentalOfficeShiftCardStatus>;

/**
 * The data (non-callback) props fed to the DS `DentalOfficeShiftCard`. Shared by every
 * job→card mapper so the shift card renders consistently across views (Shift Overview,
 * Schedule List, …). Callbacks (`onMessage`, `onCardClick`, `menuItems`) are wired by the
 * card wrapper, not the mapper.
 */
export type TShiftCardData = Pick<
  DentalOfficeShiftCardProps,
  | 'status'
  | 'statusLabel'
  | 'date'
  | 'startTime'
  | 'endTime'
  | 'hours'
  | 'rate'
  | 'profession'
  | 'office'
  | 'person'
  | 'candidates'
  | 'interview'
  | 'invitedCount'
>;
